import __request__ from "routing/request";
export function getJournalEstimate(requestOptions) {
  return __request__("GET", "/migration/journalestimate", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function serialize(requestOptions) {
  return __request__("GET", "/migration/serialize", null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function status(requestOptions) {
  return __request__("GET", "/migration/state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resetState(requestOptions) {
  return __request__("DELETE", "/migration/state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function trigger(request, requestOptions) {
  return __request__("POST", "/migration/trigger", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
